import { getSearchParams } from '../utils';

/**
 * Управляет отрисовкой промо-банера для пришедших по рекламным ссылкам.
 * Для добавления нового рекламного сообщения в шапке формы объявления нужно
 *   1. Добавить тип в HeaderPromoType ↓
 *   2. Сформировать шаблон cian/static/addform/app/blocks/header-promo/templates/[type].tpl.jade
 *   3. Если необходимы изображения, они должны лежать здесь cian/static/addform/app/resources/assets/images/header-promo
 */
export const HeaderPromoType = {
  info: 'info',
};

export default [
  () => {
    let isVisible = false;
    let type = null;

    let queryParams = getSearchParams();

    // Если в адресной строке передан ключ promo и его значение в списке допустимых
    if (queryParams && 'promo' in queryParams && Object.values(HeaderPromoType).indexOf(queryParams.promo) >= 0) {
      isVisible = true;
      type = Object.keys(HeaderPromoType).find(key => HeaderPromoType[key] === queryParams.promo);
    }

    const getType = () => {
      return type;
    };

    return {
      isVisible,
      getType,
    };
  },
];
